import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const UzbekistanFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				x='0.25'
				y='0.25'
				width='19.5'
				height='13.5'
				rx='1.75'
				fill='white'
				stroke='#F5F5F5'
				strokeWidth='0.5'
			/>
			<mask
				id='mask0_2332_16204'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					x='0.25'
					y='0.25'
					width='19.5'
					height='13.5'
					rx='1.75'
					fill='white'
					stroke='white'
					strokeWidth='0.5'
				/>
			</mask>
			<g mask='url(#mask0_2332_16204)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 4.66667H20V0H0V4.66667Z'
					fill='#04AAC8'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H20V9.33337H0V14Z'
					fill='#23C840'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M3.33287 3.73335C3.62664 3.73335 3.8997 3.64645 4.12674 3.49745C4.10044 3.49915 4.0739 3.50002 4.04715 3.50002C3.38967 3.50002 2.85668 2.97768 2.85668 2.33335C2.85668 1.68902 3.38967 1.16668 4.04715 1.16668C4.0739 1.16668 4.10044 1.16755 4.12674 1.16925C3.8997 1.02025 3.62664 0.93335 3.33287 0.93335C2.54389 0.93335 1.9043 1.56015 1.9043 2.33335C1.9043 3.10655 2.54389 3.73335 3.33287 3.73335ZM5.71382 3.26668C5.71382 3.52442 5.50062 3.73335 5.23763 3.73335C4.97464 3.73335 4.76144 3.52442 4.76144 3.26668C4.76144 3.00895 4.97464 2.80002 5.23763 2.80002C5.50062 2.80002 5.71382 3.00895 5.71382 3.26668ZM7.14239 1.86668C7.40539 1.86668 7.61858 1.65775 7.61858 1.40002C7.61858 1.14228 7.40539 0.93335 7.14239 0.93335C6.8794 0.93335 6.6662 1.14228 6.6662 1.40002C6.6662 1.65775 6.8794 1.86668 7.14239 1.86668ZM9.52334 1.40002C9.52334 1.65775 9.31015 1.86668 9.04715 1.86668C8.78416 1.86668 8.57096 1.65775 8.57096 1.40002C8.57096 1.14228 8.78416 0.93335 9.04715 0.93335C9.31015 0.93335 9.52334 1.14228 9.52334 1.40002ZM9.04715 3.73335C9.31015 3.73335 9.52334 3.52442 9.52334 3.26668C9.52334 3.00895 9.31015 2.80002 9.04715 2.80002C8.78416 2.80002 8.57096 3.00895 8.57096 3.26668C8.57096 3.52442 8.78416 3.73335 9.04715 3.73335ZM7.61858 3.26668C7.61858 3.52442 7.40539 3.73335 7.14239 3.73335C6.8794 3.73335 6.6662 3.52442 6.6662 3.26668C6.6662 3.00895 6.8794 2.80002 7.14239 2.80002C7.40539 2.80002 7.61858 3.00895 7.61858 3.26668Z'
					fill='white'
				/>
			</g>
		</svg>
	);
};

export default UzbekistanFlagIcon;
